/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* jsx-a11y/label-has-associated-control */
import React from 'react';
import advSearchState from 'Stores/advSearch';
import userDetail from 'Stores/userDetail';
import { observer } from 'mobx-react';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import CheckBox from 'Components/common/CheckBox';

const PhoneCoverageFilter = observer(props => {
  const { filterInPage = false } = props;
  let checkBoxFilters;
  if (filterInPage) checkBoxFilters = advSearchState.checkBoxFilters;
  else checkBoxFilters = advSearchFilterPopupState.checkBoxFilters;

  const {
    MOBILE_NUMBER_FILTER = false,
    DIRECT_DIAL_FILTER = false,
    ANY_PHONE_NUMBER_FILTER = false,
  } = userDetail.featureFlags;

  const onCheckBoxClick = val => {
    if (filterInPage) advSearchState.setCheckBoxFilters(val);
    else advSearchFilterPopupState.setCheckBoxFilters(val);
  };

  return (
    <div className="input-section options-section check-box-wrap">
      {ANY_PHONE_NUMBER_FILTER && (
        <div
          className={`title-checkbox${
            checkBoxFilters.displayOnlyContactsWithAnyPhoneNumbers ? ' selected' : ''
          }`}
          onClick={() => onCheckBoxClick('displayOnlyContactsWithAnyPhoneNumbers')}
        >
          <div className="check-box">
            <CheckBox
              dymamicClass={
                checkBoxFilters.displayOnlyContactsWithAnyPhoneNumbers
                  ? 'selected'
                  : ''
              }
            />
          </div>
          <span className="check-box-label nowrap-text">
            Any phone numbers
          </span>
        </div>
      )}
      {MOBILE_NUMBER_FILTER && (
        <div
          className={`title-checkbox${
            checkBoxFilters.displayOnlyMobileNumberContacts ? ' selected' : ''
          }`}
          onClick={() => onCheckBoxClick('displayOnlyMobileNumberContacts')}
        >
          <div className="check-box">
            <CheckBox
              dymamicClass={
                checkBoxFilters.displayOnlyMobileNumberContacts
                  ? 'selected'
                  : ''
              }
            />
          </div>
          <span className="check-box-label nowrap-text">
            Mobile numbers
          </span>
        </div>
      )}
      {DIRECT_DIAL_FILTER && (
        <div
          className={`title-checkbox${
            checkBoxFilters.displayOnlyDirectDialContacts ? ' selected' : ''
          }`}
          onClick={() => onCheckBoxClick('displayOnlyDirectDialContacts')}
        >
          <div className="check-box">
            <CheckBox
              dymamicClass={
                checkBoxFilters.displayOnlyDirectDialContacts ? 'selected' : ''
              }
            />
          </div>
          <span className="check-box-label">
            Direct dial numbers
          </span>
        </div>
      )}
    </div>
  );
});

export { PhoneCoverageFilter };
export default PhoneCoverageFilter;
